export const PAGE_LOAD_DURATION = 1;
export const NAVIGATION_DURATION = 0.5;
export const ANIMATION_DURATION = 0.25;
